<template>
    <div ref="QRCode"  class="QRCode" :style="{'width':width, 'height':height}">
      <!-- pc端 -->
      <canvas :id="canvasId" :style="{'width':width, 'height':height}"></canvas>
      <!-- <canvas v-show="!isMobile" :id="canvasId" @click="loadCode"  :style="{'width':width, 'height':height}"></canvas> -->
      <!-- <div class="QQMode" v-if="load || view"><a-icon type="download" @click="loadCode" v-if="load" /></div> -->
      <!-- 移动端 -->
      <!-- <el-image
      v-show="isMobile"
      :style="{'width':width, 'height':height}"
            :src="imgSrc"
            fit="fill"></el-image> -->
      <div style="text-align: center; color: red;">
          {{ hint }}
      </div>
    </div>
  </template>
  <script>
  import QRCode from "qrcode";
  export default {
    name: "QRCode",
    props: {
      content: {
        type: String,
        default: "测试二维码"
      },
      width: {
        type: String,
        default: "100"
      },
      height: {
        type: String,
        default: "100"
      },
      codeName: {
        type: String,
        default: "二维码"
      },
      load: {
        type: Boolean,
        default: true
      },
      view: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        canvasId: "",
        // imgSrc: null,
        // isMobile: false,
        hint: "请截图保存二维码",
      };
    },
    computed: {},
    created() {
      this.canvasId = this.getUUID();
      this.$nextTick(() => {
        this.init();
      });
    },
    mounted() {
      // this.isMobile=this._isMobile();
      // this.hint = this.isMobile==true?"长按二维码保存":"点击二维码保存"
    },
    methods: {
      init() {
        var refQRCode =this.$refs.QRCode;
        let width = refQRCode.offsetWidth,
          height = refQRCode.offswtHeight;
        QRCode.toCanvas(
          document.getElementById(this.canvasId),
          this.content,
          { width, height, toSJISFunc: QRCode.toSJIS },
          error => {}
        );
        // this.getSrc();
      },
      getUUID() {
        let d = new Date().getTime();
        let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function(c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
          }
        );
        return uuid;
      },
      getSrc(){
        let [F, S, a] = [
          navigator.userAgent.indexOf("Firefox") > -1,
          document.getElementById(this.canvasId).toDataURL("image/png"),
          document.createElement("a")
        ];
        // var dataurl = showel.toDataURL();
        var arr = S.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
          
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], this.codeName + ".png", { type: mime });
        this.imgSrc= URL.createObjectURL(file);
      },
      //下载二维码
      loadCode() {
        let [F, S, a] = [
          navigator.userAgent.indexOf("Firefox") > -1,
          document.getElementById(this.canvasId).toDataURL("image/png"),
          document.createElement("a")
        ];
        // var dataurl = showel.toDataURL();
        var arr = S.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
          
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], this.codeName + ".png", { type: mime });
        
        // var blob = new Blob([u8arr], {
        //   type: undefined,
        // });
        var aLink = document.createElement("a");
        aLink.download = this.codeName + ".png"; //这里写保存时的图片名称
        aLink.href = URL.createObjectURL(file);
        aLink.click();
        this.$message({
          message: "正在进行下载保存",
          type: 'success'
        })
        
        // $A.FU(file, data => {
        //   // alert(1)
        //   // window.location.href = data;
        //   [a.href, a.download] = [data, this.codeName];
        //   // a.download = '二维码';
        //   if (F) {
        //     let evt = document.createEvent("MouseEvents");
        //     evt.initEvent("click", true, true);
        //     a.dispatchEvent(evt);
        //   } else {
        //     a.click();
        //   }
        // });
      },
      //判断pc端还是移动端
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        if (flag) {
          return true
        } else {
          return false
        }
      },
      // insertContentLoad(content, size) {
      //   const ele = document.createElement("canvas");
      //   ele.style.width = size.width || "100" + "px";
      //   ele.style.height = size.height || "100" + "px";
      //   QRCode.toCanvas(
      //     ele,
      //     content,
      //     {
      //       width: size.width || "100",
      //       height: size.height || "100",
      //       toSJISFunc: QRCode.toSJIS
      //     },
      //     error => {}
      //   );
      //   let [F, S, a] = [
      //     navigator.userAgent.indexOf("Firefox") > -1,
      //     ele.toDataURL("image/png"),
      //     document.createElement("a")
      //   ];
      //   [a.href, a.download] = [S, size.name];
      //   // a.download = '二维码';
      //   if (F) {
      //     let evt = document.createEvent("MouseEvents");
      //     evt.initEvent("click", true, true);
      //     a.dispatchEvent(evt);
      //   } else {
      //     a.click();
      //   }
      // }
    },
    watch: {
      content(val) {
        this.init();
      },
    }
  };
  </script>
  <style lang="scss" scoped>
  .QRCode {
    display: inline-block;
    position: relative;
    overflow: hidden;
    .QQMode {
      position: absolute;
      left: 0;
      bottom: 100%;
      right: 0;
      height: 0;
      background-color: rgba(0, 0, 0, 0.45);
      transition: all 200ms ease-in-out;
      cursor: pointer;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 20px;
      font-weight: bolder;
      box-sizing: border-box;
      padding: 10px;
    }
  }
  .QRCode:hover .QQMode {
    bottom: 0;
    height: 100%;
  }
  </style>